import { SubmitHandler, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { joiResolver } from '@hookform/resolvers/joi';

import { redeemCoupon } from '../../../../db/courses/actions';
import { selectFullCourseId } from '../../../../db/courses/selectors';
import { CourseParams } from '../../../../pages/routes';
import { useAppSelector } from '../../../../store/hooks';
import { useRequestDispatch } from '../../../../utils/request-actions';
import { usePaymentWallContext } from '../../Context';
import { PaymentStep } from '../../types';
import { useCoursePaymentContext } from '../Context';
import { FormValues } from './types';
import { validationSchema } from './validators';

const useCouponCode = () => {
  const requestDispatch = useRequestDispatch();

  const { currentPaymentStep, setCurrentPaymentStep } = usePaymentWallContext();
  const { closeDrawer } = useCoursePaymentContext();

  const { courseShortId } = useParams<CourseParams>();
  const courseId = useAppSelector((state) => selectFullCourseId(state, courseShortId));

  const isVisible = currentPaymentStep.name === PaymentStep.COUPON_CODE;

  const formMethods = useForm<FormValues>({
    defaultValues: {
      couponCode: '',
    },
    resolver: joiResolver(validationSchema),
  });

  const { reset, setError } = formMethods;

  const handleCloseDrawer = () => {
    reset();
    closeDrawer();
  };

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    if (!courseId) return;
    try {
      const response = await requestDispatch(redeemCoupon, { courseId, coupon: data.couponCode });
      if (response.message === 'success') {
        setCurrentPaymentStep({ name: PaymentStep.PAYMENT_SUCCESS });
      } else {
        setError('couponCode', { message: response.errorMessage });
      }
    } catch (error: any) {
      setError('couponCode', error);
    }
  };

  return {
    isVisible,
    handleCloseDrawer,
    formMethods,
    onSubmit,
  };
};

export default useCouponCode;
